import { useState, type FormEvent } from "react";

const LOGIN_ACTION = "https://nxhost.com.br/cliente/dologin.php";

const inputClass =
  "w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 transition-colors focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100";

export default function ClientLoginForm() {
  const [showPassword, setShowPassword] = useState(false);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    // Formulário de login do WHMCS: envia direto para o sistema da Área do Cliente.
    const form = event.currentTarget;
    if (!form.reportValidity()) {
      event.preventDefault();
    }
  }

  return (
    <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
      <div className="mb-6">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
          <i className="ri-user-3-line text-2xl" aria-hidden="true"></i>
        </span>
        <h2 className="mt-5 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          Acesse a sua conta
        </h2>
        <p className="mt-2 text-sm text-foreground-600">
          Entre com o seu e-mail e senha para gerenciar os seus serviços, faturas e domínios.
        </p>
      </div>

      <form
        method="post"
        action={LOGIN_ACTION}
        onSubmit={handleSubmit}
        id="client-login-form"
        className="flex flex-col gap-4"
      >
        <div>
          <label htmlFor="whmcs-username" className="mb-1.5 block text-sm font-medium text-foreground-800">
            E-mail
          </label>
          <input
            id="whmcs-username"
            name="username"
            type="text"
            required
            autoComplete="username"
            placeholder="seu@email.com"
            className={inputClass}
          />
        </div>

        <div>
          <label htmlFor="whmcs-password" className="mb-1.5 block text-sm font-medium text-foreground-800">
            Senha
          </label>
          <div className="relative">
            <input
              id="whmcs-password"
              name="password"
              type={showPassword ? "text" : "password"}
              required
              autoComplete="off"
              placeholder="Sua senha"
              className={`${inputClass} pr-12`}
            />
            <button
              type="button"
              onClick={() => setShowPassword((value) => !value)}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:text-primary-600"
            >
              <i className={showPassword ? "ri-eye-off-line text-lg" : "ri-eye-line text-lg"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <button
          type="submit"
          className="mt-2 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-login-box-line text-lg" aria-hidden="true"></i>
          Entrar
        </button>
      </form>

      <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 text-sm sm:flex-row">
        <a
          href="https://nxhost.com.br/cliente/pwreset.php"
          className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-600"
        >
          <i className="ri-lock-password-line" aria-hidden="true"></i>
          Esqueci a minha senha
        </a>
        <a
          href="https://nxhost.com.br/cliente/register.php"
          className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-600"
        >
          <i className="ri-user-add-line" aria-hidden="true"></i>
          Criar uma conta
        </a>
      </div>
    </div>
  );
}